<template>
  <div class="payHome">
    <a-layout>
      <div class="payDiv">
        <div class="page-listHeader">
          <img class="imageLogin" src="./image/logo.jpg" />
        </div>
        <div class="formTable">
          <div class="fomrLeft">
            <a-form
              :form="form"
              @submit="handleSubmit"
              style="width: 96%; margin: 0 auto"
            >
              <a-form-item>
                <p class="pOne">微信支付</p>
                <p class="pTow">
                  请使用<span style="color: #87c5da">&nbsp;微信&nbsp;</span
                  ><img style="width: 20px" src="./image/Scan.jpg" /><span
                    style="color: #87c5da"
                    >&nbsp;扫一扫</span
                  >
                </p>
                <p class="pThree">扫描二维码支付</p>
              </a-form-item>
              <a-form-item>
                <img class="product-image" :src="config.urlImg + data" />
              </a-form-item>
            </a-form>
          </div>
          <div class="formRight">
            <img
              class="urlImage"
              src="../../components/weChatPayment/image/wecht.jpg"
            />
          </div>
        </div>
        <pay-yesAndNo ref="payYesAndNo"></pay-yesAndNo>
      </div>
    </a-layout>
  </div>
</template>
<script>
import payYesAndNo from '../../components/payYesAndNo/index';
export default {
  data() {
    return {
      collapsed: false,
      defaultSelectedKeys: [],
      defaultOpenKeys: [],
      urlName: [],
      form: this.$form.createForm(this),
      data: '',
      mb: '',
      outTradeNo: '',
      orderId: '',
      personId: '',
      type: null,
      checkedDaiId: null,
      // type: this.$route.query.type,
    };
  },
  components: {
    'pay-yesAndNo': payYesAndNo,
  },
  watch: {
    $route() {
      this.getUrl();
      this.getMenu();
    },
  },
  created() {
    console.log(this.type);
    this.queryPay();
    // let _this = this;
    // setTimeout(function() {
    this.queryPayState();
    // }, 1000);
  },
  methods: {
    // 跳转路由
    goRouter(value) {
      this.$router.push(value);
    },
    // 表格请求
    queryPay() {
      const url = window.location.href;
      const theRequest = new Object();
      // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
      if (url.indexOf('?') != -1) {
        //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
        const str = url.substr(url.indexOf('?') + 1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
        // return theRequest;
      }
      this.type = theRequest.type;
      this.mb = theRequest.mb;
      this.outTradeNo = theRequest.outTradeNo;
      this.orderId = theRequest.orderId;
      this.personId = theRequest.personId;
      this.checkedDaiId = theRequest.checkedDaiId;
      this.data = `/hzwmj/wxpay/payUrl?totalFee=${theRequest.mb}&outTradeNo=${theRequest.outTradeNo}&type=${this.type}`;
    },
    queryPayState() {
      //设置时间 2-秒  1000-毫秒
      let _this = this;
      setTimeout(_this.queryPayState, 2 * 1000);
      this.$http
        .get('/hzwmj/wxpay/payStatus', {
          params: {
            outTradeNo: this.outTradeNo,
            orderId: this.orderId,
            personId: this.personId,
            type: this.type == 1 ? '2' : '1',
            outTradeCharge: this.mb,
            paramType:2,
            couponId:'',
            setmealId:''
          },
        })
        .then((data) => {
          if (data.code === 200) {
            const buyData = data.data;
            console.log('==buyDatass====', buyData);
            if (buyData === '已支付') {
              if (this.checkedDaiId && this.type == 2) {
                this.$http.post('/hzwmj/person-coupon/updateCoupon', {
                  id: this.checkedDaiId,
                  couponState: '2',
                  orderId: this.orderId,
                });
              }
              this.$refs.payYesAndNo.init();
            }
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {});
    },
    //数据提交
    handleSubmit(e) {
      console.log(e);
      event.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('=====数据====', values);
        }
      });
    },
  },
};
</script>

<style lang="less">
.payHome {
  background-color: #ffffff;
  height: 100%;
  .page-spa {
    background-color: rgba(39, 86, 138, 1);
  }
  .ant-breadcrumb {
    display: inline;
  }
  .payDiv {
    position: relative;
    .page-listHeader {
      height: 280px;
      background-image: url(../../components/weChatPayment/image/header.jpg);
      .imageLogin {
        top: 20px;
        width: 300px;
        margin-top: 60px;
      }
    }
    .formTable {
      position: absolute;
      background-color: #ffffff;
      top: 70%;
      left: 10%;
      width: 80%;
      height: 600px;
      border: 1px solid #d2d1d1;
      /*box-shadow: 0 0 4px 2px #d2d1d1;*/
      box-shadow: 0 2px 12px 0 #e1e2e2;
      border-radius: 10px;
      .urlImage {
        width: 400px;
        padding-bottom: 80px;
      }
      .fomrLeft {
        display: inline-block;
        width: 24%;
        margin-right: 100px;
        .product-image {
          width: 220px;
        }
        .pOne {
          width: 90px;
          padding-top: 40px;
          font-size: 20px;
          font-weight: 500;
          top: 41px;
          margin-right: 220px;
        }
        .pTow {
          font-size: 15px;
          font-weight: 500;
        }
        .pThree {
          font-size: 15px;
          font-weight: 500;
        }
      }
      .formRight {
        display: inline-block;
        bottom: 20px;
        width: 360px;
      }
    }
  }
  overflow: hidden;
  .logo {
    width: 200px;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 5px 0 5px 0;
    float: left;
    background-size: 200px 60px;
    background-repeat: no-repeat;
  }
}
</style>
